import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCalendarFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#CalendarFilled_svg__a)">
      <path d="M7.32 9.562a.91.91 0 0 0 .904-.903V6.89h5.79a.91.91 0 0 0 .902-.902.91.91 0 0 0-.902-.903h-5.79V3.303A.91.91 0 0 0 7.32 2.4a.91.91 0 0 0-.903.903v5.356c0 .494.41.903.903.903" />
      <path d="M20.948 5.734a2.24 2.24 0 0 0-1.589-.662h-1.77v-1.77a.91.91 0 0 0-.902-.902.91.91 0 0 0-.903.903v5.344c0 .494.41.903.903.903a.91.91 0 0 0 .903-.903v-1.77h1.77c.12 0 .228.05.312.133a.44.44 0 0 1 .133.313v3.106h-15.6V7.323c0-.12.047-.228.131-.313a.44.44 0 0 1 .313-.132.91.91 0 0 0 .903-.903.91.91 0 0 0-.903-.903A2.26 2.26 0 0 0 2.4 7.323v12.038a2.26 2.26 0 0 0 2.25 2.25h14.723a2.26 2.26 0 0 0 2.25-2.25V7.31c0-.59-.24-1.167-.662-1.589l-.012.012Zm-1.155 13.627c0 .12-.048.229-.133.313a.44.44 0 0 1-.313.132H4.637a.44.44 0 0 1-.313-.132.44.44 0 0 1-.132-.313v-7.126h15.589v7.126z" />
      <path d="M6.297 15.376h11.388a.596.596 0 0 0 .602-.601.596.596 0 0 0-.602-.602H6.297a.596.596 0 0 0-.602.601c0 .338.265.602.602.602m9.787 1.289H7.922a.596.596 0 0 0-.602.601c0 .338.265.602.602.602h8.162a.596.596 0 0 0 .602-.602.596.596 0 0 0-.602-.601" />
    </g>
    <defs>
      <clipPath id="CalendarFilled_svg__a">
        <path d="M2.398 2.4h19.2v19.2h-19.2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCalendarFilled;
